<template>
  <div>
    <div class="relative bg-white rounded-2xl shadow-md p-6 mx-auto">
      <span :class="['px-4 py-1 rounded-lg font-bold text-xs absolute top-4 right-4', statusClass]">
        {{ $t(`claim_deductible.status.${claimDeductible.status}`) }}
      </span>
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2">
        <StackedField label="Franchise" :value="formatPrice(claimDeductible.price)" />
        <StackedField v-if="paid" label="Facture">
          <button @click="handleInvoiceClick" class="text-sm text-blue-400 underline cursor-pointer">
            Lien de la facture
          </button>
        </StackedField>
      </div>
    </div>
  </div>
</template>

<script>
import { StackedField, formatPrice } from "@estaly/ui";
import { mapActions, mapGetters } from "vuex";
import { toCamelCase } from "@/utils/utils";

export default {
  props: ["claimDeductible"],
  components: {
    StackedField,
  },
  computed: {
    ...mapGetters("claimDeductibles", { deductibleIsPaid: "isPaid", deductibleStatusClass: "statusClass" }),
    paid() {
      return this.deductibleIsPaid(this.claimDeductible);
    },
    statusClass() {
      return this.deductibleStatusClass(this.claimDeductible);
    },
  },
  methods: {
    formatPrice,
    ...mapActions("claimDeductibles", ["fetchInvoiceUrl"]),
    async handleInvoiceClick() {
      const response = await this.fetchInvoiceUrl({ id: this.claimDeductible.id });
      if (!response?.success) return;

      const invoiceUrl = toCamelCase(response.data).invoiceUrl;
      if (invoiceUrl) window.open(invoiceUrl, "_blank");
    },
  },
};
</script>
